import { useEffect, useRef, useState } from 'react';
import {
  Text,
  VStack,
  ButtonGroup,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { T } from '@transifex/react';
import { useAuth0 } from '@auth0/auth0-react';
import { TokenCustomClaimKeysEnum } from '@sitecore-ui/portal-singular';
import { CopyClipboardInput } from 'features/common/components/CopyClipboardInput';
interface ISystemInfoModal {
  isOpen: boolean;
  onClose: () => void;
}
const SystemInfoModal = ({ isOpen, onClose, ...rest }: ISystemInfoModal) => {
  const btnLeastDestructiveRef = useRef(null);
  const { getAccessTokenSilently, user } = useAuth0();
  const organizationId = user?.[TokenCustomClaimKeysEnum.ORG_ID];
  const [accessToken, setAccessToken] = useState('');

  useEffect(() => {
    (async () => {
      const token = await getAccessTokenSilently({
        organization_id: organizationId,
      });
      setAccessToken(token);
    })();
  }, [getAccessTokenSilently, organizationId]);

  return (
    <div data-testid='systemInfoModal'>
      <Modal
        {...rest}
        isOpen={isOpen}
        onClose={onClose}
        size='lg'
        autoFocus={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text data-testid='systemInfoModal-title'>
              <T _str='System information' />
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch" maxW='lg'>
              <CopyClipboardInput
                inputLabel='Bearer token'
                isReadOnly
                inputValueProp={accessToken}
                dataTestId='bearerTokenInput'
              />
              <CopyClipboardInput
                inputLabel='Organization ID'
                isReadOnly
                inputValueProp={organizationId}
                dataTestId='orgIdInput'
              />
            </VStack>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button
                onClick={onClose}
                ref={btnLeastDestructiveRef}
                data-testid='systemInfoModal-doneButton'
              >
                <T _str='Done' />
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default SystemInfoModal;

